import { render, staticRenderFns } from "./Stepper4.vue?vue&type=template&id=062e71e0&scoped=true&"
var script = {}
import style0 from "./Stepper4.vue?vue&type=style&index=0&id=062e71e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e71e0",
  null
  
)

export default component.exports